import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  ConfirmDialog,
  Dialog,
  InputText,
  Toast,
  Checkbox,
} from "primereact";

import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../../Base/Services/ToastService";

import {
  getCustomersDetails,
  addCustomersDetails,
} from "../../../../../../API/Compras/Customers/CustomerDetails/CustomerDetailsRequest";
import { getEstadosCategory } from "../../../../../../API/Global/Status/StatusRequests";
import { obtenerCountries } from "../../../../../../Base/API/Global/Countries/CountriesRequests";
import { getCustomersAct } from "../../../../../../API/Compras/Customers/CustomerRequests";
import Loader from "../../../../../../Base/Components/Loader/Loader";

const CustomerDetailsCrud = ({
  customerDetails,
  customerDetailsDialog,
  setCustomerDetailsDialog,
  toastRef,
  getCustomerDetails,
  modo,
}) => {
  // const userAuth = JSON.parse(localStorage.getItem('ppfUser'));

  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);
  const [customerD, setCustomerD] = useState([{}]);
  const [customer, setCustomer] = useState([{}]);
  const [paises, setPaises] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [loading, setLoading] = useState(false);


  //formato de fecha
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear().toString().slice(-2); // Obtener solo los últimos dos dígitos del año
    let hours = date.getHours();
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convertir las horas al formato de 12 horas
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${meridiem}`;
  };

  const initialValues = {
    IdCustomerDetails: -1,
    IdCustomer: "",
    IdStatus: "",
    DateCreate: formatDate(new Date()),
    RTN: "",
    CompanyName: "",
    Address: "",
    Contact: "",
    City: "",
    State: "",
    IdCountry: "",
    ZipCode: "",
    Tel: "",
    Email: "",
    IsShipTo: "",
    IsBuyer: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const cust = await getCustomersDetails();
    const estadosTempo = await getEstadosCategory("General");
    const pais = await obtenerCountries();
    const cu = await getCustomersAct();

    setCustomerD(cust);
    setEstados(estadosTempo);
    setPaises(pais);
    setCustomer(cu);

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === customerDetails?.IdStatus);

    setValues({
      ...customerDetails,
      Estado: estadoInicial,
      DateCreate:
        modo === "Crear"
          ? formatDate(new Date())
          : formatDate(customerDetails.DateCreate),
      Pais: pais.find((p) => customerDetails?.IdCountry === p.IdCountry),
      Customer: cu.find((c) => customerDetails?.IdCustomer === c.IdCustomer),
    });
    setValues((prevValues) => ({
      ...prevValues,
      IsShipTo: prevValues.IsShipTo,
      IsBuyer: prevValues.IsBuyer,
    }));
    setLoading(false)
  };

  const onHide = () => {
    setCustomerDetailsDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.CompanyName) {
      error.CompanyName = true;
      error.error = true;
    }
    if (!values.Customer || !values?.Customer.IdCustomer) {
      error.IdCustomer = true;
      error.error = true;
    }
    if (!values.Estado || !values?.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.Email)) {
      error.Email = true;
      error.error = true;
    }

    setError(error);
    // console.error(error);
    return error;
  };

  
  const estanteExistsWithSameName = () => {
    const sameNameEstantes = customerD.filter(
      (item) =>
        item.CompanyName.toLowerCase() === values.CompanyName.toLowerCase() &&
        item.IdCustomer === values.Customer.IdCustomer &&
        item.IdCustomerDetails !== values.IdCustomerDetails
    );
    return sameNameEstantes.length > 0;
  };

  const agregarCustomerDetails = async () => {
    const e = verificarInfo();
    if (!e.error) {
        if (estanteExistsWithSameName()) {
            toastShow(toastRef, "error", "Error", "Ya existe un registro con el mismo nombre en este Cliente.");
            return;
          }
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdCustomerDetails: values?.IdCustomerDetails,
          IdCustomer: values.Customer?.IdCustomer,
          IdStatus: estadoId,
          DateCreate: values.DateCreate,
          RTN: values?.RTN,
          CompanyName: values.CompanyName,
          Address: values.Address,
          Contact: values.Contact,
          City: values.City,
          State: values.State,
          IdCountry: values.Pais?.IdCountry,
          ZipCode: values.ZipCode,
          Tel: values.Tel,
          Email: values.Email,
          IsShipTo: values?.IsShipTo,
          IsBuyer: values?.IsBuyer,
        };
        const t = await addCustomersDetails(a);
        if (modo === "Crear") {
          onHide();
          toastShow(toastRef, "success", "Datos Agregados", "Customer agregado exitosamente.");
          getCustomerDetails();
        } else {
          onHide();
          toastShow(toastRef, "success", "Datos Agregados", "Customer actualizado exitosamente.");
          getCustomerDetails();
        }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarCustomerDetails();
          } else {
            agregarCustomerDetails();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (customerDetailsDialog) {
      getValoresIniciales();
    }
  }, [customerDetailsDialog]);

  const dialogTitle =
    modo === "Crear"
      ? "Agregar Detalle de Cliente"
      : "Modificar Detalle de Cliente";

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <Dialog
        visible={customerDetailsDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
        <Loader loading={loading} querySelector={"#Dialog"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
            <h1 className="fw-bold">{values.CodigoCliente}</h1>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="CompanyName"
                  value={values.CompanyName}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.CompanyName ? "p-invalid" : ""}
                />
                <label htmlFor="CompanyName">Detalle de Cliente</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Customer"}
                  value={values.Customer}
                  items={customer}
                  field={"CustomerName"}
                  label={"Cliente"}
                  handleInputChange={handleInputChange}
                  className={error.IdCustomer ? "p-invalid" : ""}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 ">
              <span className="p-float-label">
                <InputText
                  name="RTN"
                  value={values.RTN}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="RTN">RTN</label>
              </span>
            </div>

            <div className="field col-6 me-2 ">
              <span className="p-float-label">
                <InputText
                  name="Email"
                  value={values.Email}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"Fecha"}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Email ? "p-invalid" : ""}
                />
                <label htmlFor="Email">Email</label>
                {error.Email && (
                  <small className="p-error">
                    Correo electrónico iválido. E.g. example@email.com
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="Tel"
                  value={values.Tel}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"Fecha"}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="Tel">Teléfono</label>
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Pais"}
                  value={values.Pais}
                  items={paises}
                  field={"Country"}
                  label={"País"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="State"
                  value={values.State}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"Estado"}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="State">Estado</label>
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="City"
                  value={values.City}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"Ciudad"}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="City">Ciudad</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Address"
                  value={values.Address}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="Address">Dirección</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="ZipCode"
                  value={values.ZipCode}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"ZipCode"}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="ZipCode">ZipCode</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="Contact"
                  value={values.Contact}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  label={"Contacto"}
                />
                <label htmlFor="Contact">Contacto</label>
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdStatus ? "p-invalid" : ""}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <InputText
                  name="DateCreate"
                  value={values.DateCreate}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  autoComplete="off"
                  readOnly
                  label={"Fecha"}
                />
                <label htmlFor="DateCreate">Fecha de Creación</label>
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <Checkbox
                  checked={values.IsShipTo}
                  onChange={(e) =>
                    setValues({ ...values, IsShipTo: e.target.checked })
                  }
                />
                <label htmlFor="IsShipTo">&nbsp;&nbsp;&nbsp;IsShipTo</label>
              </span>
            </div>

            <div className="field col-6 me-2 ">
              <span className="p-float-label">
                <Checkbox
                  checked={values.IsBuyer}
                  onChange={(e) => setValues({ ...values, IsBuyer: e.checked })}
                />
                <label htmlFor="IsBuyer" className="ml-2">
                  &nbsp;&nbsp;&nbsp;IsBuyer
                </label>
              </span>
            </div>
          </div>
        </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CustomerDetailsCrud;
